import { getTravellerFormSchemaRequestKey } from './request/travellerSchema'

const getCheckoutTravellerSchema = (state: App.State) => state.checkout.schemaData[getTravellerFormSchemaRequestKey(state)]

export function isCheckoutTravellerSchemaReady(
  schemaData: App.Checkout.TravellerFormSchemaData | null | undefined,
  isFetchingSchema: boolean,
  isFormInitialised: boolean,
): boolean {
  return !!schemaData?.accommodationFlightSchema && !isFetchingSchema && isFormInitialised
}

export function isCheckoutTravellerReadinessSatisfied({
  isTravellerFormNeeded,
  shouldShowTravellerForm,
  isStandaloneGiftCard,
  isStandalonePurchaseCredit,
  isLoyaltyFreeLoungePassBenefitPurchase,
  schemaData,
  isFetchingSchema,
  isFormInitialised,
}: {
  isTravellerFormNeeded: boolean
  shouldShowTravellerForm: boolean
  isStandaloneGiftCard: boolean
  isStandalonePurchaseCredit: boolean
  isLoyaltyFreeLoungePassBenefitPurchase: boolean
  schemaData: App.Checkout.TravellerFormSchemaData | null | undefined
  isFetchingSchema: boolean
  isFormInitialised: boolean
}): boolean {
  if (!isTravellerFormNeeded || isStandaloneGiftCard || isStandalonePurchaseCredit || isLoyaltyFreeLoungePassBenefitPurchase) {
    return true
  }

  if (!shouldShowTravellerForm) {
    return false
  }

  return isCheckoutTravellerSchemaReady(schemaData, isFetchingSchema, isFormInitialised)
}

export default getCheckoutTravellerSchema
